import { ColumnProps } from 'antd/lib/table';
/**
 * Static Variable
 */

export const TimeFormat = 'HH:mm';
export const TimeFormatFull = 'HH:mm:ss';
export const DateFormat = 'YYYY-MM-DD';
export const DatePFormat = 'DD/MM/YYYY';
export const DTFormat = DateFormat + ' ' + TimeFormat;
export const DT0Format = DateFormat + ' ' + TimeFormat + ':00';
export const DTFullFormat = DateFormat + ' ' + TimeFormatFull;
export const TFormat = DateFormat + 'T' + TimeFormat;
export const MARKERS_TO_RESTORE = 'MARKERS_TO_RESTORE';

export const MoneyIcon = {
  eur: '€',
};

export interface TableColumnProps<T> extends ColumnProps<T> {
  dataIndex?: Extract<keyof T, string>;
}

export interface IAccount {
  Activated: boolean;
  EncryptedPassword: string;
  AllowMePasswordChange: true;
  Roles: string;
  Name: string;
  Id: string;
  Metadata: {
    Client: string;
    EMail: string;
    PhoneNumber: string;
  };
}

export type Guid = string;
